import React, { Suspense, lazy, useState, useCallback, useEffect } from "react";
import { Router, Link } from "@reach/router";

import InnerHeight from "ios-inner-height";

import { isMobile } from "react-device-detect";
import {
  TimelineMax,
  TweenMax,
  TweenLite,
  Linear,
  TextPlugin,
  ThrowPropsPlugin,
  EasePack,
  CSSPlugin,
  ScrollToPlugin,
  Power1,
  Power2,
  Power4,
  Expo,
  gsap,
} from "gsap";

import window from "global";

class Page extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    var simple_video_player = document.querySelectorAll(".simple_video_player");

    simple_video_player.forEach((this_video) => {
      var body = document.body;
      var video_thumbnail = this_video.querySelector(".video_thumbnail");
      var video_cover = this_video.querySelector(".video_cover");
      var video_box = this_video.querySelector(".main_video");
      var video = video_cover.querySelector("video");
      var video_close_btn = video_cover.querySelector(".close_btn");
      var video_time = video_cover.querySelector(".video_time");

      var play_btn = video_cover.querySelector(".play_btn");
      play_btn.addEventListener("click", handlePlayButton, false);

      async function playVideo() {
        try {
          await video.play();
          video_box.classList.add("playing");
        } catch (err) {
          video_box.classList.remove("playing");
        }
      }

      function handlePlayButton() {
        if (video.paused) {
          playVideo();
        } else {
          video.pause();
          video_box.classList.remove("playing");
        }
      }

      video.addEventListener("click", function() {
        video_box.classList.remove("playing");
      });

      video_box.style.height = window.innerHeight + "px";

      video_close_btn.addEventListener("click", function() {
        body.classList.remove("video_plaing");
        video_box.classList.remove("playing");
        video.pause();
        console.log("2");
      });

      video_thumbnail.addEventListener("click", function() {
        video_box.style.height = window.innerHeight + "px";
        body.classList.add("video_plaing");
        video_box.classList.add("playing");
        playVideo();
        var i = setInterval(function() {
          if (video.readyState > 0) {
            // var minutes = parseInt(video.duration / 60, 10);
            // var seconds = video.duration % 60;
            video_time.innerHTML =
              parseInt(video.duration) - parseInt(video.currentTime);
            if (parseInt(video.duration) - parseInt(video.currentTime) == 0) {
              clearInterval(i);
              body.classList.remove("video_plaing");
              video_box.classList.remove("playing");
              video.pause();
            }
          }
        }, 1000);
      });
    });
  }

  componentWillUnmount() {}

  render() {
    return (
      <>
        <div className="simple_video_player">
          <div
            className="video_thumbnail photo ratio_16_9"
            style={{
              backgroundImage: `url(${require("../../images/greenisland2021_mainvideo_cover-3.jpg")})`,
            }}
          >
            <div className="play_btn">
              <i className="fa fa-play"></i>
            </div>
          </div>
          <div className="video_cover">
            <div className="main_video">
              <video
                src={require("../../greenisland2021_mainvideo-s.mp4")}
                poster={require("../../images/greenisland2021_mainvideo_cover-3.jpg")}
                controls
                className="video"
              ></video>
              <div className="play_btn">
                <i className="fa fa-play"></i>
              </div>
            </div>
            <div className="video_time"></div>
            <div className="close_btn">✕</div>
          </div>
        </div>
      </>
    );
  }
}

export default Page;
